module.exports = __webpack_public_path__ + "static/media/IMG_4501 storage.5f0610ea.JPG";